interface FooterProps {
  footerText: string;
}

const Footer = (props: FooterProps) => {
  const { footerText } = props;
  return (
    <section className="App_Footer">
      <footer
        className={`z-10 max-w-5xl w-full items-center justify-between font-mono text-sm lg:flex"`}
      >
        <h1>{footerText}</h1>
      </footer>
    </section>
  );
};

export default Footer;
